import { makeStyles } from "@material-ui/core/styles";
import {
  IconButton,
  Button,
  withStyles
} from "@material-ui/core";

export const useServiceFeeStyle = makeStyles(theme => ({
  rootContainer: { minWidth: "40vw" },
  gridTitle: {
    fontWeight: "bold"
  },
  gridTitleContainer: {
    marginLeft: theme.spacing(2)
  },
  textfield:{
    marginTop: theme.spacing(2)
  },
  fieldLabel:{
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    marginTop: 5,
    fontWeight: "bold"
  },
  serviceFeeInfoContainer: {
    margin: theme.spacing(2)
  },
  serviceFeeName: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      minWidth: "150px"
    }
  },
  serviceFeeAmount: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      minWidth: "150px"
    }
  },
  applyzerotransactionflag: {
    marginTop: theme.spacing(3),
  },
  sectionBreak: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  delBtn: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(3)
  },
  saveBtn: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3)
  },
  mobileViewDelBtn: {
    color: "error",
    float: "right",
    marginRight: theme.spacing(2)
  },
  mobileViewSaveBtn: {
    float: "right",
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
}));

export const StyledIconButton = withStyles({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
})(IconButton);

export const StyledButton = withStyles({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
})(Button);
